import { CtaButton } from "@/components/CtaButton";
import { Reveal, SectionHead, Em } from "@/components/Reveal";
import { site } from "@/config/site.config";

const bonuses = [
  {
    img: "/assets/bonus-rituals.jpg",
    inside: "/assets/inside-rituals.jpg",
    tag: "BONUS 01 — QUANTUM HABITS",
    title: "7 DAILY RITUALS",
    sub: "Small rituals. Massive results.",
    desc: "A daily-rhythm program inside your bundle: the 7 daily rituals, accountability, inner child meditation, rituals hypnosis, pattern disruption meditation, an unconditional-love rite of passage, and dance rituals — the practices that keep the vision alive every single day.",
  },
  {
    img: "/assets/bonus-blueprint.jpg",
    inside: "/assets/inside-blueprint.jpg",
    tag: "BONUS 02",
    title: "THE BLUEPRINT",
    sub: "Dasha’s method for creating belief shift.",
    desc: "Her unique method for changing what you believe is possible: shifting beliefs about money and freedom, reprogramming relationship patterns, money mantras, the Your Why Identity Masterclass, identity-embodiment sessions, and the make-a-copy Blueprint framework.",
  },
];

export const BonusSection = () => (
  <section data-testid="bonus-section" className="border-y border-white/10 bg-coal">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
      <SectionHead eyebrow="WAIT — THERE’S MORE INSIDE" center>
        TWO BONUS PROGRAMS.
        <br />
        SAME <Em>$27.</Em>
      </SectionHead>

      <div className="grid gap-6 lg:grid-cols-2">
        {bonuses.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.12}>
            <div className="group h-full overflow-hidden rounded-2xl border border-gold/20 bg-card" data-testid={`bonus-card-${i + 1}`}>
              <div className="overflow-hidden">
                <img
                  src={b.img}
                  alt={`${b.title} — bonus program by Dasha Love`}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <div className="p-6 sm:p-8">
                <p className="font-mono text-[10px] tracking-[0.3em] text-gold">{b.tag}</p>
                <h3 className="mt-2 text-2xl font-extrabold tracking-tight text-cream sm:text-3xl">{b.title}</h3>
                <p className="mt-1 font-serif text-lg italic text-lime">{b.sub}</p>
                <p className="mt-4 text-sm leading-relaxed text-cream/65">{b.desc}</p>
                <figure className="mt-6">
                  <div className="overflow-hidden rounded-xl border border-white/10">
                    <img
                      src={b.inside}
                      alt={`Inside the ${b.title} members area`}
                      loading="lazy"
                      className="w-full object-cover"
                      data-testid={`bonus-inside-${i + 1}`}
                    />
                  </div>
                  <figcaption className="mt-2 text-center font-mono text-[9px] tracking-[0.3em] text-cream/40">
                    INSIDE THE MEMBERS AREA
                  </figcaption>
                </figure>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14 text-center">
        <p className="font-mono text-xs tracking-[0.3em] text-cream/50">
          COURSE + 3 BOOKS + BOTH BONUS PROGRAMS
          <br />
          <span className="text-lime">ALL INCLUDED — ONE PAYMENT OF {site.price}</span>
        </p>
        <div className="mt-6">
          <CtaButton id="bonus">GET EVERYTHING — {site.price}</CtaButton>
        </div>
      </Reveal>
    </div>
  </section>
);
